import classNames from "classnames";
import "./OpticksIconText.css";

interface Props {
  icon?: React.ReactNode;
  text: string | React.ReactNode;
  size?: "s" | "m" | "l" | "xl" | "inherit";
  disabled?: boolean;
  weight?: "normal" | "bold";
  truncate?: boolean;
  textRef?: React.Ref<HTMLSpanElement>;
}

const OpticksIconText = ({
  icon,
  text,
  size = "m",
  disabled = false,
  weight = "bold",
  truncate = true,
  textRef,
}: Props) => {
  return (
    <div
      className={classNames(
        "opticks-icon-text",
        `size-${size}`,
        `weight-${weight}`,
        { disabled },
        { truncate }
      )}
    >
      {icon != null && (
        <span className="opticks-icon-text__icon">{icon}</span>
      )}
      <span ref={textRef}>{text}</span>
    </div>
  );
};

export default OpticksIconText;
